import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import CenterSearch from "../components/Center/Search";

const Home = () => {
  const { isAuthenticated, logout } = useContext(AuthContext);

  return (
    <div>
      <main className="flex-shrink-0">
        <header className="py-5">
          <div className="container px-5 pb-5">
            <div className="row gx-5 align-items-center">
              <div className="col-xxl-5">
                <div className="text-center text-xxl-start">
                  <div className="badge bg-gradient-primary-to-secondary text-white mb-4">
                    <div className="text-uppercase">CareUs &middot; 케어스</div>
                  </div>
                  <div className="fs-3 fw-light text-muted">어르신을 위해 안심하고 맡기세요.</div>
                  <h1 className="display-4 fw-bolder mb-5"><span className="text-solid-primary d-inline">케어스(CareUs)가<br />신뢰할 수 있는<br />방문간호센터를<br />찾아드립니다.</span>
                  </h1>
                  <div className="d-grid gap-3 d-sm-flex justify-content-sm-center justify-content-xxl-start mb-3">
                    {/* {isAuthenticated ? ( 
                        <a className="btn btn-primary btn-lg px-5 py-3 me-sm-3 fs-6 fw-bolder" style={{cursor: "pointer"}} onClick={logout}>로그아웃</a>
                    ) : (
                        <a className="btn btn-primary btn-lg px-5 py-3 me-sm-3 fs-6 fw-bolder" href="/login">로그인</a>
                    )} */}
                    <a className="btn btn-outline-dark btn-lg px-5 py-3 fs-6 fw-bolder" href="#search">센터검색</a>
                  </div>
                </div>
              </div>
              <div className="col-xxl-7">
                <div className="d-flex justify-content-center mt-5 mt-xxl-0">
                  {/* <div className="profile bg-gradient-primary-to-secondary"> */}
                  <div className="profile">
                    <img className="profile-img" src="/assets/images/06.png" alt="..." />
                    {/* <div className="dots-1">
                      <svg version="1.1" x="0" y="0" viewBox="0 0 191.6 1215.4" style={{ enableBackground: "new 0 0 191.6 1215.4" }}>
                        <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">
                          <path
                            d="M227.7 12788.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 12788.6c-151-50-253-216-222-362 25-119 136-230 254-255 194-41 395 142 375 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 11508.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 11508.6c-151-50-253-216-222-362 25-119 136-230 254-255 194-41 395 142 375 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 10228.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 10228.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 8948.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 8948.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 7668.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 7668.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 6388.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 6388.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 5108.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 5108.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 3828.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 3828.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 2548.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 2548.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 1268.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 1268.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                        </g>
                      </svg>
                    </div>
                    <div className="dots-2">
                    <svg viewBox="0 0 191.6 1215.4" style={{ enableBackground: "new 0 0 191.6 1215.4"}}>
                        <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">
                          <path
                            d="M227.7 12788.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 12788.6c-151-50-253-216-222-362 25-119 136-230 254-255 194-41 395 142 375 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 11508.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 11508.6c-151-50-253-216-222-362 25-119 136-230 254-255 194-41 395 142 375 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 10228.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 10228.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 8948.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 8948.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 7668.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 7668.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 6388.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 6388.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 5108.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 5108.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 3828.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 3828.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 2548.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 2548.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 1268.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 1268.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                        </g>
                      </svg>
                    </div>
                    <div className="dots-3">
                      <svg viewBox="0 0 191.6 1215.4" style={{ enableBackground: "new 0 0 191.6 1215.4"}}>
                        <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">
                          <path
                            d="M227.7 12788.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 12788.6c-151-50-253-216-222-362 25-119 136-230 254-255 194-41 395 142 375 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 11508.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 11508.6c-151-50-253-216-222-362 25-119 136-230 254-255 194-41 395 142 375 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 10228.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 10228.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 8948.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 8948.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 7668.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 7668.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 6388.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 6388.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 5108.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 5108.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 3828.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 3828.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 2548.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 2548.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 1268.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 1268.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                        </g>
                      </svg>
                    </div>
                    <div className="dots-4">
                      <svg viewBox="0 0 191.6 1215.4" style={{ enableBackground: "new 0 0 191.6 1215.4"}}>
                        <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">
                          <path
                            d="M227.7 12788.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 12788.6c-151-50-253-216-222-362 25-119 136-230 254-255 194-41 395 142 375 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 11508.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 11508.6c-151-50-253-216-222-362 25-119 136-230 254-255 194-41 395 142 375 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 10228.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 10228.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 8948.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 8948.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 7668.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 7668.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 6388.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 6388.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 5108.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 5108.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 3828.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 3828.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 2548.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 2548.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M227.7 1268.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                          <path
                            d="M1507.7 1268.6c-105-35-200-141-222-248-43-206 163-412 369-369 155 32 275 190 260 339-11 105-90 213-190 262-61 29-155 36-217 16z" />
                        </g>
                      </svg>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section className="bg-light py-5" id="search">
          <div className="container px-5">
            <div className="row gx-5 justify-content-center">
              {/* <div className="col-xxl-8">
                <div className="text-center my-5">
                  <h2 className="display-5 fw-bolder"><span className="text-gradient d-inline">About Me</span></h2>
                  <p className="lead fw-light mb-4">My name is Start Bootstrap and I help brands grow.</p>
                  <p className="text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit dolorum itaque qui
                    unde quisquam consequatur autem. Eveniet quasi nobis aliquid cumque officiis sed rem iure ipsa!
                    Praesentium ratione atque dolorem?</p>
                  <div className="d-flex justify-content-center fs-2 gap-4">
                    <a className="text-gradient" href="#!"><i className="bi bi-twitter"></i></a>
                    <a className="text-gradient" href="#!"><i className="bi bi-linkedin"></i></a>
                    <a className="text-gradient" href="#!"><i className="bi bi-github"></i></a>
                  </div>
                </div>
              </div> */}
              <CenterSearch />
            </div>
          </div>
        </section>
      </main>
      {/* <footer className="bg-white py-4 mt-auto">
        <div className="container px-5">
          <div className="row align-items-center justify-content-between flex-column flex-sm-row">
            <div className="col-auto">
              <div className="small m-0">Copyright &copy; Your Website 2023</div>
            </div>
            <div className="col-auto">
              <a className="small" href="#!">Privacy</a>
              <span className="mx-1">&middot;</span>
              <a className="small" href="#!">Terms</a>
              <span className="mx-1">&middot;</span>
              <a className="small" href="#!">Contact</a>
            </div>
          </div>
        </div>
      </footer> */}
    </div>
  );
};

export default Home;
